/* ===========================================================================
   Password
   =========================================================================== */

const $formPassWord = document.querySelectorAll('.js-password');

/**
 * [showPassword description]
 * @param  {[type]} $elem [description]
 * @return {[type]}       [description]
 */
function showPassword($elem) {
  $elem.setAttribute('type', 'text');
}

/**
 * [hidePassword description]
 * @param  {[type]} $elem [description]
 * @return {[type]}       [description]
 */
function hidePassword($elem) {
  $elem.setAttribute('type', 'password');
}

if ($formPassWord) {

  /**
   * [description]
   * @param  {[type]} e) {             const $this [description]
   * @return {[type]}    [description]
   */
  [...$formPassWord].forEach(function(item) {

      item.addEventListener('click', function(e) {

      const $this = e.target;

      if ($this && $this.matches('.js-show-password')) {

        const $input = $this.parentNode.querySelector('input');
        const type = $input.getAttribute('type');

        $this.classList.toggle('icon-eye');
        $this.classList.toggle('icon-eye-blocked');

        if (type === 'password')
          showPassword($input);
        else
          hidePassword($input);

      }

    });

  });

}
